import { GetterTree } from 'vuex';
import { RootState } from '@/store';
import { BulkState } from './types';

export const getters: GetterTree<BulkState, RootState> = {
};
